module.exports = __webpack_public_path__ + "static/img/2003.8c388fa0.jpg";